import { Signal }             from "signals"
import _                      from "lodash"
import { observable, action } from "mobx"
import store                  from "store"
import shop2                  from "shop/shop"

function generateUID() {
  let firstPart = (Math.random() * 46656) | 0;
  let secondPart = (Math.random() * 46656) | 0;
  firstPart = ("000" + firstPart.toString( 36 )).slice( -3 );
  secondPart = ("000" + secondPart.toString( 36 )).slice( -3 );
  return firstPart + secondPart;
}

let shop = false

function makeOrderlist( name ) {
  return {
    items: null, sum: 0, size: 0, name
  }
}

function makeStoredProduct( { map_id, unit_id, unit_multi, count }, active = true ) {
  return {
    map_id, count, active, unit_id, unit_multi
  }
}

class ListModel {
  @observable products = {} // holds the full product data
  @observable items = new Map() // holds reduced products
  @observable hash = 0
  
  constructor( { id, customName, title, sum, size, etag, isArchived = false, items = [] } ) {
    this.id = id || generateUID()
    this.isArchived = !(isArchived === false)
    this.customName = customName
    this.title = title
    this.sum = sum || 0
    this.etag = etag || false
    this.size = size || 0
    this.events = {}
    this.events.change = new Signal()
    _.map( items, (( item ) => {
      this.items.set( item.map_id, item )
    }) )
    this.hydrate()
    shop.events.authentified.add( () => {
      this.load()
    } )
  }
  
  load = () => {
    // console.log( "LOADING", this.title, this.items )
    let allProducts = _.map( [...this.items], (( pair ) => {
      let item = pair[ 1 ]
      // console.log( "LOADING", this.title, item.map_id )
      return shop.product( item.map_id )
                 .then( product => {
                   if ( !product ) {
                     this.remove( item )
                     return
                   }
                   product.count = item.count
                   product.unit_multi = item.unit_multi || product.unit_multi
                   product.unit_id = item.unit_id || product.unit_id
                   this.products[ product.map_id ] = product
                   return product
                 }, err => {
                   console.error( err )
                   this.remove( item )
                 } )
    }) )
    
    this.size = _.size( this.items )
    return Promise.all( allProducts )
                  .then( () => {
                    this.update()
                    this.events.change.dispatch( { list: this } )
                  } )
  }
  
  async toCart( product ) {
    let listPosition = this.items.get( product.map_id )
    // console.log( "ADD === ", shop.cart.getPID( product ), product )
    product.count = listPosition.count || 1
    await shop2.cart.add( product )
    // shop.toast(translate("Warenkorb aktualisiert"))
  }
  
  listToCart() {
    // console.log( { products: this.products } )
    _.forEach( this.products, ( item ) => {
      this.toCart( item )
    } )
  }
  
  contains( product ) {
    return !!this.items.get( product.map_id )
  }
  
  @action
  toggle( product ) {
    if ( this.contains( product ) ) {
      this.remove( product )
    } else {
      this.add( product )
    }
    
    this.hash++
  }
  
  @action
  add( product = {}, active = true ) {
    // product.count = product.count
    let { map_id, unit_id, unit_multi, count, extras } = product
    if ( !map_id ) return false
    
    count = count || 1
    this.items.set( map_id, { map_id, unit_id, unit_multi, count, active, extras } )
    this.hash++
    return shop.product( map_id )
               .then( p => {
                 p.count = count
                 p.unit_multi = product.unit_multi
                 p.unit_id = product.unit_id
                 this.items.set( map_id, { map_id, unit_id, unit_multi, count, active, extras } )
                 this.products[ map_id ] = p
                 this.size = _.size( this.items )
                 this.update()
                 this.dispatch()
               } )
  }
  
  @action
  remove( { map_id } ) {
    this.items.set( map_id, false )
    delete this.products[ map_id ]
    this.size = _.size( this.items )
    this.update()
  }
  
  dispatch() {
    this.events.change.dispatch( { list: this } )
  }
  
  @action
  update() {
    let price = 0
    let size = 0
    let totalCount = 0
    
    _.forEach( this.products, product => {
      let item = this.items.get( product.map_id )
      if ( !item ) return
      price += product.calculate( item.count || 1 )
      size++
      totalCount += product.count
      let { map_id, unit_id, unit_multi, count, active } = product
      this.items.set( map_id, { map_id, unit_id, unit_multi, count, active } )
    } )
    this.sum = price
    this.count = totalCount
    this.size = size
    this.dispatch()
    this.hash++
  }
  
  save() {
    const listId = `list-${this.title}`
    const listData = {
      isArchived: this.isArchived,
      items: this.items,
      customName: this.customName,
      title: this.title,
      sum: this.sum,
      size: this.size
    }
    store.set( listId, listData )
    return shop.store.server.post( listId, listData )
    
  }
  
  async hydrate() {
    let saved = store.get( "list-" + this.title ) || makeOrderlist( this.title )
    _.forEach( saved.items, item => {
      if ( item && item.map_id ) {
        if ( !this.items.get( item.map_id ) ) {
          this.items.set( item.map_id, item )
        }
      }
    } )
    this.customName = this.customName || saved.customName
  }
}

export default class OrderlistService {
  constructor( opts ) {
    shop = opts.shop
    this.lists = {}
    this.events = {}
    this.events.change = new Signal()
    this.listnames = store.get( "listnames" ) || []
    this.hydrate()
    this.default = this.list( "Merkliste" )
    shop.events.authentified.add( this.onLogin )
  }
  
  onLogin = () => {
    this.hydrate()
  }
  
  async hydrate() {
    
    let saved = store.get( "listnames" ) || []
    _.forEach( saved, title => {
      let list = this.lists[ title ] || new ListModel( { title } )
      this.lists[ title ] = list
      list.update()
    } )
    
    this.events.change.dispatch( { lists: this.lists } )
    
    return this.all()
  }
  
  createList( listData ) {
    const title = listData.title
    // console.log( { listData, title } )
    let list = new ListModel( listData )
    list.load()
    this.lists[ title ] = list
    // console.log( "CREATE LIST", list )
    return list
  }
  
  remove( listname ) {
    let list = this.lists[ listname ]
    if ( list ) {
      list.isArchived = true
      list.save()
    }
    delete this.lists[ listname ]
    store.remove( "list-" + listname )
    this.listnames = _.filter( this.listnames, ( e ) => {
      return e != listname
    } )
    store.set( "listnames", this.listnames )
    this.events.change.dispatch( { lists: this.lists } )
  }
  
  toggle( listname, product ) {
    // console.log( `adding product to List`, listname )
    let list = this.list( listname )
    list.add( product )
  }
  
  all() {
    return this.lists
  }
  
  get( title ) {
    return this.list( title )
  }
  
  list( title ) {
    let list
    if ( !_.includes( this.listnames, title ) ) {
      // console.log( `new list -`, title )
      this.listnames.push( title )
      store.set( "listnames", this.listnames )
      list = this.lists[ title ] = new ListModel( { title } )
      this.events.change.dispatch( { lists: this.lists } )
    } else {
      list = this.lists[ title ]
    }
    return list || console.error( "No List" )
  }
  
}



// WEBPACK FOOTER //
// ./src/sdk/OrderlistService.js